import React, { useEffect, useState } from "react";
import eventEmitter from "shared/events";
import VarietyPacks from "../form-inputs/variety-packs";
import ReadOnlyVarietyPacks from "../form-inputs/variety-packs/read-only";

const SectionLaunch = (props) => {
    const [isSectionActive, setIsSectionActive] = useState(false);
    useEffect(() => {
        return () => {
            document.body.classList.remove("-hide-scroll");
        };
    }, []);

    const openSection = (e) => {
        if (e.altKey) {
            return;
        }

        setIsSectionActive(true);
        eventEmitter.emit("PAUSE_WINDOW_VISIBLE", true);
        document.body.classList.add("-hide-scroll");
    };

    const closeSection = () => {
        setIsSectionActive(false);
        eventEmitter.emit("PAUSE_WINDOW_VISIBLE", false);
        document.body.classList.remove("-hide-scroll");
    };

    if (!isSectionActive) {
        return (
            <button className="button" onClick={openSection}>
                {props.disabled ? "View" : props.launchLabel || "Edit"}
            </button>
        );
    }

    return (
        <div className="page-takeover">
            {props.readOnly || props.disabled ? (
                <ReadOnlyVarietyPacks launchLabel="View" readOnly={true} handleClose={closeSection} defaultValue={props.defaultValue} {...props} />
            ) : (
                <VarietyPacks handleClose={closeSection} defaultValue={props.defaultValue} {...props} />
            )}
        </div>
    );
};

export default SectionLaunch;
